export default "__VITE_ASSET__CmQffgrt__"